export function debounce<TArgs extends unknown[], TResult>(
  fn: (...args: TArgs) => TResult,
  delay: number
): (...args: TArgs) => void {
  let timeoutId: ReturnType<typeof setTimeout>

  return function (...args: TArgs) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn(...args), delay)
  }
}
